module.exports = __webpack_public_path__ + "static/media/DSC08918.a47953f6.jpg";